/**
 * Formats file size in bytes to megabytes with 2 decimal places
 * @param {number} bytes - File size in bytes
 * @returns {string} - Formatted file size in MB (e.g., "1.50 MB")
 */
export function formatFileSize(bytes) {
  const megabytes = (bytes / 1024) / 1024
  return `${megabytes.toFixed(2)} MB`
}
